import React from 'react';
import {
  Button,
  Form,
  Grid,
  Header,
  Icon,
  Input,
  Message,
  Modal
} from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

type LoginProps = {
  disabled?: boolean,
  loginFailed: boolean,
  onClose?(): void,
  onLogin(): void,
  onPasswordChange(_password: string): void,
  onUsernameChange(_username: string): void,
  onForgotPassword?(): void,
  open: boolean,
  placeholder: string
};

const LoginModal = (props: LoginProps) => {

  const {disabled, loginFailed, onLogin, onClose, onPasswordChange, onUsernameChange, open, placeholder, onForgotPassword} = props;
  const { t } = useTranslation();

  return (
    <Modal
      as={Form}
      className='login-modal'
      error={loginFailed}
      open={open}
      size='small'
    >
      <Header
        icon='user circle'
        content={t('LoginModal.header')}
      />
      <Message
        error
        header={t('LoginModal.loginErrorHeader')}
        content={t('LoginModal.loginErrorContent')}
      />
      <Grid
        padded='vertically'
        textAlign='center'
      >
        <Grid.Column>
          <Grid.Row>
            <Input
              autoFocus
              className='form-field'
              icon={<Icon name='at' />}
              onChange={(e, data) => onUsernameChange(data.value)}
              placeholder={placeholder}
              size='huge'
            />
          </Grid.Row>
          <Grid.Row
            className='row'
          >
            <Input
              className='form-field'
              icon={<Icon name='lock' />}
              onChange={(e, data) => onPasswordChange(data.value)}
              placeholder={t('LoginModal.password')}
              size='huge'
              type='password'
            />
          </Grid.Row>
        </Grid.Column>
      </Grid>
      <Modal.Actions>
        <Button
          disabled={disabled}
          onClick={onLogin}
          primary
          size='large'
          type='submit'
        >
          {t('LoginModal.buttonLogin')}
        </Button>
        {onClose && (
          <Button
            basic
            onClick={onClose}
            size='large'
          >
            {t('LoginModal.buttonCancel')}
          </Button>
        )}
        {onForgotPassword &&
          <Button
            basic
            onClick={onForgotPassword}
            size='large'
          >
            {t('LoginModal.forgotPassword')}
          </Button>
        }

      </Modal.Actions>

    </Modal>
  )
}

export default LoginModal;